import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PeersTabValue } from '../../constants';
import { SidebarContent } from '../../types';

type SidebarState = {
    sidebarContent: SidebarContent | null;
    peersTab: PeersTabValue | null;
};
const initialState: SidebarState = {
    sidebarContent: null,
    peersTab: null,
};
export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        setSidebarContent(state, action: PayloadAction<SidebarContent | null>) {
            state.sidebarContent = action.payload;
            if (action.payload === null) {
                state.peersTab = PeersTabValue.Conference;
            }
        },
        setPeersTab(state, action: PayloadAction<PeersTabValue | null>) {
            state.peersTab = action.payload;
        },
        resetSidebar() {
            return initialState;
        },
    },
});

export const sidebarReducer = sidebarSlice.reducer;
export const { setSidebarContent, resetSidebar, setPeersTab } = sidebarSlice.actions;
